import { render, staticRenderFns } from "./ReviewBar.vue?vue&type=template&id=db4aefac&"
import script from "./ReviewBar.vue?vue&type=script&lang=js&"
export * from "./ReviewBar.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports